import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useSplitTestControlGroupWeightSelector = (id: string) => {
  const state = useGetEditOrActual();

  return useMemo(() => state.splitTests[id]?.controlGroupWeight, [id, state.splitTests]);
};
